import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import MessagesModal from './components/MessagesModal'

const PermissionsScreen = ({
  token,
  brand,
  language,
  startDate,
  endDate,
}: {
  token: string
  brand: string
  language: string
  startDate: string
  endDate: string
}) => {
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [permissionsDenied, setPermissionsDenied] = useState(false)

  useEffect(() => {
    const requestPermissions = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ video: true, audio: true })

        navigate(
          `/zoom/meeting/${token}?brand=${brand}&language=${language}&start_date=${startDate}&end_date=${endDate}`,
        )
      } catch (error) {
        console.error('Permisos denegados:', error)
        setPermissionsDenied(true)
        localStorage.setItem('permissionsDenied', 'true')
        setIsModalOpen(true)
      }
    }

    requestPermissions()
  }, [navigate])

  return (
    <MessagesModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      brand={brand}
      language={language}
      startDate={startDate}
      endDate={endDate}
      token={token}
      permissionsDenied={permissionsDenied}
    />
  )
}

export default PermissionsScreen
